import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { FaTimes } from "react-icons/fa";
import Player from "@vimeo/player";
import {updateUserILEARNProgress} from "../../sagas/actions";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const VideoPlayerContainer = styled.div`
  width: 80%;
  max-width: 700px;
  background-color: ${(props) => props.colors.colors.formBackground};
  border-radius: 5px;
  overflow: hidden;
  position: relative;
`;

const SectionHeader = styled.div`
  font-size: 1rem;
  font-weight: bold;
  padding: 15px 20px;
  color: white;
  background-color: ${(props) => props.colors.colors.buttonBackground};
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.span`
  flex: 1;
  text-align: center;
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  font-size: 1.2rem;
  color: white;
  cursor: pointer;

  &:hover {
    color: #ccc;
  }
`;

const VideoContent = styled.div`
  padding: 20px;
`;

const VideoIframe = styled.iframe`
  width: 100%;
  height: 315px;
  border: none;
  border-radius: 5px;
`;

const ILEARNVideoPlayer = ({
  videoId,
  title,
  closeModal,
  colors,
  chapterId,
  moduleId,
  onVideoComplete,
  disableSeeking = false,
}) => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.auth.user);

  useEffect(() => {
    const iframe = document.querySelector("iframe");
    const player = new Player(iframe);
    let lastTime = 0;

    if (disableSeeking) {
      // Prevent seeking
      player.on("timeupdate", (event) => {
        const currentTime = event.seconds;
        if (currentTime > lastTime + 1) {
          // User tried to seek forward, reset to last known time
          player.setCurrentTime(lastTime);
        } else {
          lastTime = currentTime; // Update last known time
        }
      });
    }

    // Detect video completion
    player.on("ended", async () => {
      try {
          dispatch(updateUserILEARNProgress({module_no: moduleId, chapter_no: chapterId, ilearn_code : "edu", user_id : user.user_id}))
        closeModal(); // Close the modal
      } catch (error) {
        console.error("Error updating user progress:", error);
      }
    });

    return () => {
      if (disableSeeking) {
        player.off("timeupdate");
      }
      player.off("ended");
    };
  }, [videoId, chapterId, moduleId, closeModal, onVideoComplete, disableSeeking]);

  return (
    <ModalOverlay>
      <VideoPlayerContainer colors={colors}>
        <SectionHeader colors={colors}>
          <CloseButton onClick={closeModal} aria-label="Close">
            <FaTimes />
          </CloseButton>
          <Title>{title}</Title>
        </SectionHeader>
        <VideoContent>
          <VideoIframe
            src={`https://player.vimeo.com/video/${videoId}?api=1&player_id=player_1`}
            title="Vimeo video player"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
          />
        </VideoContent>
      </VideoPlayerContainer>
    </ModalOverlay>
  );
};

export default ILEARNVideoPlayer;
